
import React, {useEffect} from 'react';
import {
  ApplicationDownPaymentResponse,
  DownPaymentPaymentThankYouPage, 
  hasValue,
  toDollars,
} from "@amsanalytics/react-shared-library";
import {useSelector} from "react-redux";
import {AppState} from "../../Store/rootReducer";
import {loadLibrary, setClient} from "../../Store/Shared/actions";
import {
  getDownPaymentHistories,
  loadCuratedApplicationDetails
} from "../../Store/CuratedVehicles/actions";
import {useParams} from "react-router";
import {useAppDispatch} from "../../Store/useAppDispatch";
import MessageViewer from "../Controls/MessageViewer/MessageViewer";

export interface PortalDownPaymentThankYouPageProps {
  headerAndFooterHeight: number;
}

export default function PortalDownPaymentThankYouPage (props: PortalDownPaymentThankYouPageProps) {
  const params = useParams();
  const downPaymentHistories = useSelector((state: AppState) => state.curatedVehicles.downPaymentHistories);
  const applicationDetails = useSelector((state: AppState) => state.curatedVehicles.application);
  const clientId = (params as any)?.clientId;
  const customerPortalLinkId = (params as any)?.customerPortalLinkId;
  const dispatch = useAppDispatch();
  const loadingDetail = useSelector((state: AppState) => state.curatedVehicles.loading);
  const applicationDetailsLoaded = loadingDetail.applicationDetailsLoaded;
  const thankYouPageConfig = useSelector((state: AppState) => state.curatedVehicles.thankYouPageConfig);

  const getLatest = (items: ApplicationDownPaymentResponse[]): ApplicationDownPaymentResponse | undefined => {
    if (items.length === 0) return undefined;

    return items.reduce((latest, current) => {
      // If current date is null, keep the latest
      if (current.cashDrawerDate === null) return latest;

      // If latest date is null, use current
      if (latest.cashDrawerDate === null) return current;

      const latestDate = new Date(latest.cashDrawerDate).getTime();
      const currentDate = new Date(current.cashDrawerDate).getTime();
      return currentDate > latestDate ? current : latest;
    });
  };

  const downPaymentToDisplay = getLatest(downPaymentHistories);
  
  useEffect(() => {
    // Load lookups if we have enough info.
    const clientIdFromParams = (params as any)?.clientId;
    if (clientIdFromParams) {
      if (clientId !== clientIdFromParams) {
        dispatch(setClient((params as any)?.clientId));
      }

      if (!applicationDetailsLoaded) {
        dispatch(loadCuratedApplicationDetails(clientIdFromParams, customerPortalLinkId));
      }
      
      dispatch(loadLibrary(clientId));
    }
  }, []);
  
  useEffect(() => {
    // Load lookups if we have enough info.
    const clientIdFromParams = (params as any)?.clientId;
    if (applicationDetails && clientIdFromParams && downPaymentHistories.length === 0) {
      dispatch(getDownPaymentHistories(applicationDetails!.applicationId, clientId));
    }
  }, [applicationDetails?.applicationId, clientId]);
  
  const useContinueButton = thankYouPageConfig && hasValue(thankYouPageConfig.downPaymentThankYouRedirectLink) && hasValue(thankYouPageConfig.downPaymentThankYouButtonText);
  const handleContinue = () => window.location.href = thankYouPageConfig!.downPaymentThankYouRedirectLink!;
  
  return (
    <>
      {downPaymentToDisplay &&
        <DownPaymentPaymentThankYouPage
          paymentAmount={toDollars(downPaymentToDisplay.amount)}
          receiptNumber={downPaymentToDisplay.receipt}
          headerAndFooterHeight={props.headerAndFooterHeight}
          onContinue={useContinueButton ? handleContinue : undefined}
          buttonText={useContinueButton ? thankYouPageConfig!.downPaymentThankYouButtonText! : undefined}
        />
      }
      <MessageViewer />
    </>
  );
}
